var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 61.5,
    r: 60,
    stroke: "#459AA4",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7969 33.7086C81.9995 32.5064 83.6303 31.8311 85.3307 31.8311C87.0312 31.8311 88.662 32.5064 89.8646 33.7086",
    stroke: "#459AA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2617 29.1728C77.4527 27.9818 78.8666 27.037 80.4227 26.3924C81.9789 25.7478 83.6467 25.416 85.3311 25.416C87.0154 25.416 88.6832 25.7478 90.2394 26.3924C91.7955 27.037 93.2094 27.9818 94.4004 29.1728",
    stroke: "#459AA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_405_91",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.6462,
    cy: 37.1384,
    rx: 1.89231,
    ry: 1.89231
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.5385 37.1384H85.5385C85.5385 37.0789 85.5867 37.0307 85.6462 37.0307V39.0307V41.0307C87.7959 41.0307 89.5385 39.2881 89.5385 37.1384H87.5385ZM85.6462 39.0307V37.0307C85.7057 37.0307 85.7539 37.0789 85.7539 37.1384H83.7539H81.7539C81.7539 39.2881 83.4966 41.0307 85.6462 41.0307V39.0307ZM83.7539 37.1384H85.7539C85.7539 37.1979 85.7057 37.2461 85.6462 37.2461V35.2461V33.2461C83.4966 33.2461 81.7539 34.9887 81.7539 37.1384H83.7539ZM85.6462 35.2461V37.2461C85.5867 37.2461 85.5385 37.1979 85.5385 37.1384H87.5385H89.5385C89.5385 34.9887 87.7959 33.2461 85.6462 33.2461V35.2461Z",
    fill: "#459AA4",
    mask: "url(#path-4-inside-1_405_91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5537 86.3389H59.1537",
    stroke: "#459AA4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9541 50.8057H53.6874",
    stroke: "#459AA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9541 61.7383H53.6874",
    stroke: "#459AA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9541 72.6719H53.6874",
    stroke: "#459AA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6211 50.8057H67.3544",
    stroke: "#459AA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6211 61.7383H67.3544",
    stroke: "#459AA4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0205 86.3387V42.6053C40.0205 41.1567 40.5972 39.7654 41.6222 38.7404C42.6472 37.7154 44.0385 37.1387 45.4872 37.1387H72.8205C74.2692 37.1387 75.6604 37.7154 76.6854 38.7404C77.7104 39.7654 78.2872 41.1567 78.2872 42.6053V61.7387",
    stroke: "#459AA4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9306 75.2461C71.3336 73.5846 73.6971 73.5846 74.1002 75.2461C74.1607 75.4957 74.2792 75.7275 74.4462 75.9226C74.6132 76.1177 74.8239 76.2706 75.0612 76.3689C75.2984 76.4672 75.5555 76.5081 75.8116 76.4883C76.0676 76.4684 76.3154 76.3884 76.5346 76.2547C77.9946 75.3653 79.6664 77.0362 78.777 78.4971C78.6435 78.7163 78.5636 78.9638 78.5438 79.2197C78.524 79.4756 78.5649 79.7325 78.663 79.9696C78.7612 80.2068 78.914 80.4174 79.1089 80.5843C79.3038 80.7513 79.5353 80.8699 79.7847 80.9306C81.4461 81.3336 81.4461 83.6971 79.7847 84.1002C79.5351 84.1607 79.3033 84.2792 79.1082 84.4462C78.9131 84.6132 78.7601 84.8239 78.6618 85.0612C78.5635 85.2984 78.5227 85.5555 78.5425 85.8116C78.5624 86.0676 78.6424 86.3154 78.7761 86.5346C79.6655 87.9946 77.9946 89.6664 76.5337 88.777C76.3145 88.6435 76.0669 88.5636 75.8111 88.5438C75.5552 88.524 75.2982 88.5649 75.0611 88.663C74.824 88.7612 74.6134 88.914 74.4464 89.1089C74.2795 89.3038 74.1608 89.5353 74.1002 89.7847C73.6971 91.4461 71.3336 91.4461 70.9306 89.7847C70.8701 89.5351 70.7515 89.3033 70.5846 89.1082C70.4176 88.9131 70.2069 88.7601 69.9696 88.6618C69.7324 88.5635 69.4752 88.5227 69.2192 88.5425C68.9631 88.5624 68.7154 88.6424 68.4961 88.7761C67.0362 89.6655 65.3644 87.9946 66.2537 86.5337C66.3872 86.3145 66.4671 86.0669 66.487 85.8111C66.5068 85.5552 66.4659 85.2982 66.3677 85.0611C66.2695 84.824 66.1168 84.6134 65.9219 84.4464C65.727 84.2795 65.4955 84.1608 65.2461 84.1002C63.5846 83.6971 63.5846 81.3336 65.2461 80.9306C65.4957 80.8701 65.7275 80.7515 65.9226 80.5846C66.1177 80.4176 66.2706 80.2069 66.3689 79.9696C66.4672 79.7324 66.5081 79.4752 66.4883 79.2192C66.4684 78.9631 66.3884 78.7154 66.2547 78.4961C65.3653 77.0362 67.0362 75.3644 68.4971 76.2537C69.4432 76.829 70.6694 76.32 70.9306 75.2461Z",
    stroke: "#459AA4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6768 82.5152C69.6768 83.268 69.9758 83.99 70.5081 84.5223C71.0404 85.0546 71.7624 85.3537 72.5152 85.3537C73.268 85.3537 73.99 85.0546 74.5223 84.5223C75.0546 83.99 75.3537 83.268 75.3537 82.5152C75.3537 81.7624 75.0546 81.0404 74.5223 80.5081C73.99 79.9758 73.268 79.6768 72.5152 79.6768C71.7624 79.6768 71.0404 79.9758 70.5081 80.5081C69.9758 81.0404 69.6768 81.7624 69.6768 82.5152Z",
    stroke: "#459AA4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.554,
    height: 72.5385,
    fill: "white",
    transform: "translate(15 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons20);
export default __webpack_public_path__ + "static/media/Icons20.e803a12942f0cfa75917b12ff24cab40.svg";
export { ForwardRef as ReactComponent };